import client from '../client';
import type { TranslationGroup, SaveTranslationInput } from '../../types/translation';
import type { ApiResponse } from '../../types/api';

export const translationsApi = {
  list: async (storeId: string) => {
    const res = await client.get<ApiResponse<{ groups: TranslationGroup[] }>>(
      `/dashboard/${storeId}/translations`,
    );
    return res.data.data!;
  },

  save: async (storeId: string, data: SaveTranslationInput) => {
    await client.post(`/dashboard/${storeId}/translations`, data);
  },

  autoTranslate: async (
    storeId: string,
    data: { entityType: string; entityId: string; sourceLanguage: string; targetLanguage: string },
  ) => {
    const res = await client.post<ApiResponse<{ translations: Record<string, string>; tokensUsed: number }>>(
      `/dashboard/${storeId}/translations/auto-translate`,
      data,
    );
    return res.data.data!;
  },

  getStats: async (storeId: string) => {
    const res = await client.get<ApiResponse<{ stats: Record<string, { total: number; translated: number; percentage: number }> }>>(
      `/dashboard/${storeId}/translations/stats`,
    );
    return res.data.data!;
  },

  deleteTranslation: async (storeId: string, data: { entityType: string; entityId: string; language: string }) => {
    await client.post(`/dashboard/${storeId}/translations/delete`, data);
  },

  bulkTranslate: async (
    storeId: string,
    data: { entityType: string; targetLanguage: string; sourceLanguage: string; entityIds?: string[] },
  ) => {
    const res = await client.post<ApiResponse<{ translated: number; skipped: number; total: number; tokensUsed: number }>>(
      `/dashboard/${storeId}/translations/bulk-translate`,
      data,
    );
    return res.data.data!;
  },
};
